import React, { useRef } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { useHover } from 'react-native-web-hooks';
import { Image } from 'react-native-web';
import TableText from '../PanelsComponents/Text/TableText';
import { img_close } from '../../utils/ImagesManagementUtils';
import ServicesTableColumn from './ServicesTableColumn';
import { delete_type } from '../../utils/DictionaryManagementUtils';

const UserTypeRow = ({
  allServices, userType, index, removeRow, isDefaultRow, onConfigChanged,
}) => {
  const indexRef = useRef(null);
  const rowRef = useRef(null);
  const isHoveredIndex = useHover(indexRef);
  const isHoveredRow = useHover(rowRef);

  const myStyles = {
    row: {
      flexDirection: 'row', backgroundColor: isHoveredRow ? '#edf2f7' : '#f7fafc',
    },
    defaultRow: {
      flexDirection: 'row',
      backgroundColor: '#e2e8f0',
    },
    squareIndex: {
      width: 30,
      padding: 'auto',
      paddingVertical: 13,
      border: 'solid 1px #cbd5e0',
    },
    squareTypeID: {
      width: 100,
    },
    squareDescription: {
      width: 100,
    },
    squareServices: {
      flex: 1,
    },
    squareBorder: {
      paddingHorizontal: 8,
      paddingVertical: 13,
      border: 'solid 1px #cbd5e0',
    },
    closeImage: {
      marginHorizontal: 'auto',
      borderRadius: 4,
      width: 20,
      height: 20,
      tintColor: '#008cff',
      backgroundColor: '#ffffff',
    },
    deleteToolTipContainer: {
      backgroundColor: '#E2E8F0',
      zIndex: 2,
      width: 127,
      height: 44,
      borderRadius: 8,
      padding: 12,
      marginTop: 5,
      boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
    },
    deleteToolTip: {
      margin: 'auto', fontSize: 16,
    },
  };
  if (!userType) {
    userType = {
      typeID: '',
      description: '',
      services: '',
    };
  }
  const {
    typeID, description, services,
  } = userType;
  const notChosenServices = allServices.filter(
    (service) => !userType.services.includes(service),
  );
  const onChangeValue = (key, value) => {
    userType[key] = value;
    onConfigChanged();
    console.log(userType);
  };

  return (
    <View ref={rowRef} style={isDefaultRow ? myStyles.defaultRow : myStyles.row}>
      <View ref={indexRef} style={[myStyles.squareIndex]}>
        {!isDefaultRow && isHoveredIndex ? (
          <View>
            <TouchableOpacity
              onPress={() => removeRow(index)}
            >
              <Image
                style={myStyles.closeImage}
                source={img_close}
              />
            </TouchableOpacity>
            <View style={myStyles.deleteToolTipContainer}>
              <Text style={myStyles.deleteToolTip}>{delete_type}</Text>
            </View>
          </View>
        )
          : <TableText isMergingAuto text={index} isDefaultRow={isDefaultRow} />}

      </View>
      <View style={[myStyles.squareTypeID, myStyles.squareBorder, { zIndex: -1 }]}>
        <TableText
          isTypeIdColumn
          text={typeID}
          onChangeValue={!isDefaultRow ? (text) => onChangeValue('typeID', text) : null}
          isDefaultRow={isDefaultRow}
        />
      </View>
      <View style={[myStyles.squareDescription, myStyles.squareBorder, { zIndex: -1 }]}>
        <TableText
          text={description}
          onChangeValue={!isDefaultRow ? (text) => onChangeValue('description', text) : null}
          isDefaultRow={isDefaultRow}
        />
      </View>
      <View style={[myStyles.squareServices, myStyles.squareBorder, { zIndex: -1 }]}>
        {isDefaultRow ? <TableText text="All services" isDefaultRow /> : (
          <ServicesTableColumn
            serviceIds={services}
            onChangeServices={!isDefaultRow ? (servicesNew) => onChangeValue('services', servicesNew) : null}
            notChosenServices={notChosenServices}
          />
        )}
      </View>
    </View>
  );
};

export default UserTypeRow;
